import { Login } from '../../../../interfaces/auth.interface';
import { Validation } from '../../../../interfaces/common';
import {
  VALIDATION_FIELD_MAPPING,
  APP_ERROR_MESSAGES,
  Regex,
  MaxLength,
  MinLength,
} from '../../../../utils/appConstant';

export const validateLoginForm = (formData: Login, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.phoneNumber) {
    if (!formData.phoneNumber.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.phoneNumber,
        message: APP_ERROR_MESSAGES.login.blankPhoneNumber,
      });
    } else if (!Regex.phone.test(formData.phoneNumber.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.phoneNumber,
        message: APP_ERROR_MESSAGES.login.invalidPhoneNumber,
      });
    }
  }

  // if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.password) {
  //   if (!formData.password.trim()) {
  //     validations.validate = false;
  //     validations.fields.push({
  //       field: VALIDATION_FIELD_MAPPING.password,
  //       message: APP_ERROR_MESSAGES.login.blankPassword,
  //     });
  //   } else if (formData.password.length < MinLength.login.password) {
  //     validations.validate = false;
  //     validations.fields.push({
  //       field: VALIDATION_FIELD_MAPPING.password,
  //       message: APP_ERROR_MESSAGES.login.shortPassword,
  //     });
  //   } else if (formData.password.length > MaxLength.login.password) {
  //     validations.validate = false;
  //     validations.fields.push({
  //       field: VALIDATION_FIELD_MAPPING.password,
  //       message: APP_ERROR_MESSAGES.login.longPassword,
  //     });
  //   }
  // }

  return validations;
};
